export default __webpack_public_path__ + "static/media/27.31ab1a45.jpg";